<template lang="pug">
  app-dialog(v-model="$_show" width="300" header="Выбрать период" :confirm-disabled="noReady" confirm-text="Далее" @confirm="handleConfirm")
    app-date-picker(v-model="start" :max="end" type="date" view-format="DD.MM.YYYY")
    app-date-picker(v-model="end" :min="start" type="date" view-format="DD.MM.YYYY")
</template>

<script>
import AppDialogToggable from './AppDialogToggable'
import moment from 'moment'
moment.locale('ru')

export default {
  mixins: [AppDialogToggable],
  name: 'app-dialog-date-picker-period',

  computed: {
    period () {
      let text = moment(this.start).format('DD.MM.YYYY') + " - " + moment(this.end).format('DD.MM.YYYY')
      let start = moment(this.start).format('YYYY-MM-DD')
      let end = moment(this.end).format('YYYY-MM-DD')
      return { text, type: "day", start, end }
    },

    noReady () {
      return this.start == null || this.end == null
    }
  },

  methods: {
    handleConfirm () {
      this.$emit('confirm', this.period)
    }
  },

  data () {
    return {
      start: null,
      end: null
    }
  }
}
</script>